module.exports = __webpack_public_path__ + "img/insider_banner_dektop_1x.e9ed7081.png";